<template>
  <div id="study-status-list" class="h-full">
    <vx-card class="h-full overflow-scroll">
      <div class="flex items-center">
        <span class="text-xl mr-4">「{{ task.name }}」 - 完成情况</span>
        <v-select v-model="selected" :options="options" />
      </div>
      <vs-divider/>
      <vs-table ref="table" pagination :max-items="8" search :data="list" :hoverFlat="true">
        <div slot="header">
          <div class="btn-group">
            <vs-button type="line" size="small">已完成（{{ completedNum }}人）</vs-button>
            <vs-button type="line" size="small">完成中（{{ learningNum }}人）</vs-button>
            <vs-button type="line" size="small">{{ task.type == 3?'未发送':'未开始' }}（{{ noStartedNum }}人）</vs-button>
          </div>
        </div>
        <template slot="thead">
          <vs-th>姓名</vs-th>
          <vs-th>作品名称</vs-th>
          <vs-th>作品类型</vs-th>
          <vs-th>作品状态</vs-th>
          <vs-th>得分</vs-th>
          <vs-th>更新时间</vs-th>
          <vs-th>操作</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p>{{ tr.name }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.title? tr.title:'-' }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.type? tr.type == 'homework'?'课后作业':'课堂练习':'-' }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.is_finish !== undefind? tr.is_finish == 1?'已完成':'未完成':task.type == 3?'未发送':'未开始' }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.score? tr.score:'-' }}</p>
              </vs-td>
              <vs-td>
                <p>{{ tr.update_time?tr.update_time:'-' }}</p>
              </vs-td>
              <vs-td>
                <div v-if="tr.is_finish !== undefind && tr.is_finish == 1">
                  <vs-button class="mr-2" color="warning" size="small" type="filled" @click="openGradePage(tr.id)">查看并评分</vs-button>
                  <!-- <vs-button v-if="tr.type" color="warning" size="small" type="filled" @click="openTemp">分享</vs-button> -->
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import { classList, getStudentTaskList } from '@/api/school'

export default {
  props: {
    taskId: {
      required: true
    },
    taskName: {
      required: true
    },
    chapterId: {
      require: true
    },
    courseId: {
      require: true
    }
  },
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      task: {
        id: 0,
        name: '',
        type: 3,
        task_type: 'project'
      },
      list: [],
      options: [],
      selected: '',
      completedNum: 0,
      learningNum: 0,
      noStartedNum: 0,
    }
  },
  mounted() {
    this.task.id = this.taskId
    this.task.name = this.taskName
    this.getClassList()
  },
  watch: {
    selected(val) {
      this.getStudentTaskList()
    },
    taskId(val) {
      this.task.id = val
      this.getStudentTaskList()
    },
    taskName(val) {
      this.task.name = val
    }
  },
  computed: {
    
  },
  methods: {
    getClassList() {
      classList().then(res => {
        if (res.code == 1) {
          res.data.list.forEach(item => {
            this.options.push({id:item.id, label:item.name})
          });
          if (this.options.length > 0) {
            this.selected = this.options[0]
          }
        }
      })
    },
    getStudentTaskList() {
      getStudentTaskList({
        class_id: this.selected.id, 
        task_id: this.task.id, 
      }).then(res => {
        if (res.code == 1) {
          this.task = res.data.task
          this.list = res.data.list
          this.completedNum = res.data.completed
          this.learningNum = res.data.learning
          this.noStartedNum = res.data.nostarted
        }
      })
    },
    openTemp() {
      this.$vs.dialog({
        color: 'primary',
        title: '提示',
        text: '测试任务正在研发中，暂时不可以查询成绩记录。',
        acceptText: '好的',
      })
    },
    openGradePage(id) {
      this.$router.push({path: '/task/grade', query: {id: id, chapterId: this.chapterId, courseId: this.courseId}})
      // let routeUrl = this.$router.resolve({path: '/task/grade', query: {id: id}})
      // window.open(routeUrl.href, 'grade')
    },
  },
  
  
}
</script>

<style lang="scss">
#study-status-list {
  white-space: nowrap;
}
</style>
